import type { FC, ReactNode } from 'react';
import React, { useId, useState } from 'react';

import { MediaLightboxStoreContextProvider } from './MediaLightboxStoreContext';
import { createMediaLightboxStore } from './createMediaLightboxStore';

export interface MediaLightboxStoreProviderProps {
  readonly children: ReactNode;
}

export const MediaLightboxStoreProvider: FC<MediaLightboxStoreProviderProps> = ({ children }) => {
  const instanceId = useId();
  const [store] = useState(() => createMediaLightboxStore(instanceId));

  return <MediaLightboxStoreContextProvider store={store}>{children}</MediaLightboxStoreContextProvider>;
};
